(ns kyber.db.pdf-viewer
  (:require [clojure.spec.alpha :as s]

            [kyber.utils :refer [element?]]))

(def initial-state {:actions nil
                    :activity-title nil
                    :container nil
                    :current-page nil
                    :current-scale nil
                    :document-api nil
                    :description nil
                    :document-loaded false
                    :ecid nil
                    :lock-scroll-update false
                    :related-resources nil
                    :search-api nil
                    :search-results []
                    :selected-search-result nil
                    :title nil
                    :topics nil
                    :type nil
                    :total-pages nil
                    :total-search-results nil
                    :url nil
                    :viewer-api nil})

(s/def :actions/add-to-notes fn?)
(s/def :actions/download fn?)
(s/def :actions/recommend fn?)
(s/def ::actions (s/nilable (s/keys :opt-un [:actions/add-to-notes
                                             :actions/download
                                             :actions/recommend])))
(s/def ::activity-title (s/nilable string?))
(s/def ::container (s/nilable element?))
(s/def ::current-page (s/nilable number?))
(s/def ::current-scale (s/nilable number?))
(s/def ::description (s/nilable string?))
(s/def ::document-api (s/nilable any?))
(s/def ::document-loaded boolean?)
(s/def ::ecid (s/nilable simple-keyword?))
(s/def ::lock-scroll-update boolean?)
(s/def :related-resource/date string?)
(s/def :related-resource/description string?)
(s/def :related-resource/thumb string?)
(s/def :related-resource/title string?)
(s/def :related-resource/url string?)
(s/def ::related-resource (s/keys :req-un [:related-resource/date
                                           :related-resource/description
                                           :related-resource/thumb
                                           :related-resource/title
                                           :related-resource/url]))
(s/def ::related-resources (s/nilable (s/coll-of ::related-resource)))
(s/def :selected-search-result/result number?)
(s/def :selected-search-result/spot any?) ;; TODO s/cat
(s/def ::selected-search-result
  (s/nilable (s/keys :req-un [:selected-search-result/result
                              :selected-search-result/spot])))
(s/def ::search-api (s/nilable any?))
(s/def ::search-results (s/coll-of (s/coll-of number?)))
(s/def ::title (s/nilable string?))
(s/def ::topics (s/nilable (s/coll-of string?)))
(s/def ::total-pages (s/nilable number?))
(s/def ::total-search-results (s/nilable number?))
(s/def ::type (s/nilable string?))
(s/def ::url (s/nilable string?))
(s/def ::viewer-api (s/nilable any?))

(s/def ::pdf-viewer (s/keys :req-un [::actions
                                     ::activity-title
                                     ::container
                                     ::current-page
                                     ::current-scale
                                     ::document-api
                                     ::description
                                     ::document-loaded
                                     ::ecid
                                     ::lock-scroll-update
                                     ::search-api
                                     ::search-results
                                     ::selected-search-result
                                     ::title
                                     ::topics
                                     ::type
                                     ::total-pages
                                     ::total-search-results
                                     ::url
                                     ::viewer-api]))
